import React from "react";
import { motion } from "framer-motion";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  className?: string;
}

export const Logo = ({
  size = "md",
  showText = true,
  className = "",
}: LogoProps) => {
  const sizes = {
    sm: { container: "h-8 w-8", text: "text-lg" },
    md: { container: "h-12 w-12", text: "text-xl" },
    lg: { container: "h-16 w-16", text: "text-2xl" },
  };

  return (
    <div className={`flex items-center ${className}`}>
      <motion.div
        initial={{ rotate: 0 }}
        whileHover={{ rotate: 5 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
        className={`${sizes[size].container} rounded-full bg-cleoMed-secondary flex items-center justify-center relative overflow-hidden`}
      >
        <img
          src="/logo.png"
          alt="CleoMed Logo"
          className="w-2/3 h-2/3 object-contain"
        />
      </motion.div>

      {showText && (
        <motion.div
          initial={{ opacity: 0, x: -5 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="ml-2 flex items-center"
        >
          <span
            className={`font-bold ${sizes[size].text} text-cleoMed-secondary`}
          >
            Cleo<span className="text-cleoMed-primary">Med</span>
          </span>
          <span className="ml-1 text-xs text-gray-500 font-medium">
            Livreur
          </span>
        </motion.div>
      )}
    </div>
  );
};

export default Logo;
